import React, { useEffect, useState, Fragment } from 'react';
import Tablereact from '../../common/tabulator/tablereact'
import Loader from '../../common/loaderapp';
import Banners from './banners';
import { getBannerTypeLabel } from '../../../constant/bannerTypes';
// import Detalle from './detalle'

const TablaBanners = () => {

    const [pag_actualizar, setPag_actualizar] = useState(-1);
    const [load, setLoad] = useState(true);
    const [datos, setDatos] = useState([]);

    useEffect(() => {
   /*      console.log('==== CARGANDO BANNERS DESDE TABLA ====');
        console.log('URL:', '/p_banners');
        console.log('Método:', 'POST');
        console.log('pag_actualizar:', pag_actualizar); */
        
        fetch('/p_banners', {method : 'POST', body: JSON.stringify({}), headers: {'Content-Type': 'application/json'}})
        .then(res => {
        /*     console.log('==== RESPUESTA RECIBIDA ====');
            console.log('Status:', res.status);
            console.log('OK:', res.ok); */
            return res.json();
        })
        .then(res => {
     /*        console.log('==== DATOS PARSEADOS ====');
            console.log('Tipo de datos:', typeof res);
            console.log('Es array?:', Array.isArray(res));
            console.log('Cantidad de registros:', Array.isArray(res) ? res.length : 'No es array');
            console.log('Datos completos:', res);
            console.log('Primer registro:', res && res[0] ? res[0] : 'No hay registros'); */
            
            setDatos(formatBannerRows(res))
            setLoad(true)
        })
        .catch(err => {
/*             console.log('==== ERROR AL CARGAR BANNERS ====');
            console.log('Error:', err);
            console.log('Error message:', err.message); */
        })
    }, [pag_actualizar]);

    const formatBannerDate = (value) => {
        if (!value) return ''
        const date = new Date(value)
        if (Number.isNaN(date.getTime())) return String(value)
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear()
        return `${day}/${month}/${year}`
    }

    const formatBannerRows = (items = []) => {
        if (!Array.isArray(items)) return []
        return items.map(item => {
            const rawOrder = item?.ORDEN_BANNER ?? item?.orden_banner ?? null
            const numericOrder = Number(rawOrder)
            return {
                ...item,
                ORDEN_BANNER: Number.isFinite(numericOrder) ? numericOrder : rawOrder,
                TIPO_BANNER_LABEL: getBannerTypeLabel(item?.TIPO_BANNER),
                FECHA_ALTA_BANNER_FORMAT: formatBannerDate(item?.FECHA_ALTA_BANNER)
            }
        })
    }

    const cabecera = [
        { Header: <b>Banner</b>, accessor: 'NOMBRE_BANNER', style: { textAlign: 'center'}, width: 150, show: true }, 
        { Header: <b>Tipo</b>, accessor: 'TIPO_BANNER_LABEL', style: { textAlign: 'center'}, width: 180, show: true},
        { Header: <b>Orden</b>, accessor: 'ORDEN_BANNER', style: { textAlign: 'center'}, width: 80, show: true},
        { Header: <b>Plaza</b>, accessor: 'NOMBRE_SUCURSAL_US', style: { textAlign: 'center'}, minWidth: 250, show: true}, 
        { Header: <b>Estatus</b>, accessor: 'ESTATUS', style: { textAlign: 'center'}, width: 100, show: true},
        { Header: <b>Fecha</b>, accessor: 'FECHA_ALTA_BANNER_FORMAT', style: { textAlign: 'center'}, width: 180, show: true},
    ];

    const agregar=()=>setPag_actualizar(0)
    const detalle_dato=(dato)=>{setPag_actualizar(dato.ID_BANNER_ADMIN)}
    
    return (
        <Fragment>
            {
                load ?
                    (pag_actualizar == -1) ?
                    <div className="col-sm-12">
                        <div className="card">

                            <div className="card-body datatable-react">
                                <Tablereact
                                    myData={datos}
                                    cabecera={cabecera}
                                    pageSize={10}
                                    paginacion={true}
                                    buscador='Buscar'
                                    detalle={detalle_dato}
                                    boton={{text:'Agregar',function:agregar}}
                                />
                            </div>
                        </div>
                    </div>
                    :
                    <Banners pag_actualizar={pag_actualizar} setPag_actualizar={setPag_actualizar}/>
                :
                <Loader/>
            }
        </Fragment>
    );

}
 
export default TablaBanners;
